import { Box, Typography } from "@mui/material";

const DetailsCard = ({ header, subHeading1, value1, subHeading2, value2, subHeading3, value3 }) => {
  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.mode === "dark" ? "#1e1e1e" : "#fff",
        borderRadius: "8px",
        padding: "2em",
        marginBottom: "2em",
        border: (theme) => `1px solid ${theme.palette.mode === "dark" ? "#333" : "#E5E7EB"}`,
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        {header}
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" }, gap: 2 }}>
        <Box>
          <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
            {subHeading1}
          </Typography>
          <Typography variant="body1">{value1}</Typography>
        </Box>
        <Box>
          <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
            {subHeading2}
          </Typography>
          <Typography variant="body1">{value2}</Typography>
        </Box>
        <Box>
          <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
            {subHeading3}
          </Typography>
          <Typography variant="body1">{value3}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default DetailsCard;
